import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { RoleOptionsValues } from './helpers/constants';
import Login from './components/Authentication/Login';
import ResetPassword from './components/Authentication/ResetPassword';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import Korisnici from './components/Korisnici/Container';
import { NavigationPath } from './helpers/constants';
import Register from './components/Authentication/Register/Container';
import EditUser from './components/Korisnici/EditUser/Container';
import Dobavljaci from './components/Dobavljaci/Container';
import AddSupplier from './components/Dobavljaci/AddSupplier';
import EditSupplier from './components/Dobavljaci/EditSupplier/Container';
import Dokumentacija from './components/Dokumentacija';
import Dashboard from './components/Dashboard';
import Provizija from './components/Provizija';
import Score from './components/Score';
import Afip from './components/Afip/Container';
import Ponude from './components/Ponude';
import AddOffer from './components/Ponude/AddOffer';
import EditOffer from './components/Ponude/EditOffer';
import Brendovi from './components/Brendovi';
import AddBrandForm from './components/Brendovi/AddBrand';
import PageNotFound from './components/PageNotFound';
import EditBrandForm from './components/Brendovi/EditBrand';
import OfferRequests from './components/OfferRequests';
import AddOfferRequest from './components/OfferRequests/AddRequest';
import OfferResponses from './components/OfferResponses';
import ResponseSingle from './components/OfferResponses/ResponseSingle';
import InsuranceResponseInfo from './components/OfferResponses/ResponseSingle/InsuranceResponseInfo';
import SPremiumPrivateRoute from './SPremiumPrivateRoute';

const { LEASING_ADMIN, LEASING_KORISNIK, DOBAVLJAC_ADMIN, DOBAVLJAC_KORISNIK } =
  RoleOptionsValues;
const currentUser = localStorage.getItem('currentUser');
const loggedUser =
  currentUser && currentUser !== 'undefined' ? JSON.parse(currentUser) : null;
const role = loggedUser?.role || null;

const AppContainer = () => (
  <Routes>
    <Route path={NavigationPath.LOGIN_ROUTE} element={<Login />} />
    <Route
      path={NavigationPath.RESET_PASSWORD_ROUTE}
      element={<ResetPassword />}
    />
    <Route path="*" element={<PageNotFound />} />
    <>
      <Route path="/" element={<PrivateRoute />}>
        {role === LEASING_ADMIN && (
          <Route
            path={NavigationPath.DASHBOARD_ROUTE}
            element={<Dashboard />}
          />
        )}
        {role === LEASING_ADMIN && (
          <Route
            path={NavigationPath.SUPPLIERS_ROUTE}
            element={<Dobavljaci />}
          />
        )}
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.ADD_SUPPLIER} element={<AddSupplier />} />
        )}
        {role === LEASING_ADMIN && (
          <Route
            path={NavigationPath.EDIT_SUPPLIER}
            element={<EditSupplier />}
          />
        )}
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.BRANDS_ROUTE} element={<Brendovi />} />
        )}
        {role === LEASING_ADMIN && (
          <Route
            path={NavigationPath.ADD_BRAND_ROUTE}
            element={<AddBrandForm />}
          />
        )}
        {role === LEASING_ADMIN && (
          <Route
            path={NavigationPath.EDIT_BRAND_ROUTE}
            element={<EditBrandForm />}
          />
        )}
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.USERS_ROUTE} element={<Korisnici />} />
        )}
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.REGISTER_USER} element={<Register />} />
        )}
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.EDIT_USER} element={<EditUser />} />
        )}

        <Route path={NavigationPath.OFFERS_ROUTE} element={<Ponude />} />

        <Route
          path={NavigationPath.WEB_CALCULATOR_ROUTE}
          element={<AddOffer />}
        />
        <Route path={NavigationPath.EDIT_OFFER} element={<EditOffer />} />
        {role === LEASING_ADMIN && (
          <Route path={NavigationPath.AFIP_ROUTE} element={<Afip />} />
        )}
        <Route
          path={NavigationPath.DOCUMENTACION_ROUTE}
          element={<Dokumentacija />}
        />
        {role === LEASING_KORISNIK && (
          <Route path={NavigationPath.SCORE_ROUTE} element={<Score />} />
        )}

        {role !== LEASING_ADMIN && !loggedUser?.hidebuttonProvision && (
          <Route
            path={NavigationPath.COMMISSION_ROUTE}
            element={<Provizija />}
          />
        )}
        <Route element={<SPremiumPrivateRoute />}>
          {(role === LEASING_ADMIN || role === LEASING_KORISNIK) && (
            <Route
              path={NavigationPath.OFFER_REQUESTS_ROUTE}
              element={<OfferRequests />}
            />
          )}

          {(role === LEASING_ADMIN || role === LEASING_KORISNIK) && (
            <Route
              path={NavigationPath.ADD_OFFER_REQUEST_ROUTE}
              element={<AddOfferRequest />}
            />
          )}

          {(role === LEASING_ADMIN || role === LEASING_KORISNIK) && (
            <Route
              path={NavigationPath.OFFER_RESPONSES_ROUTE}
              element={<OfferResponses />}
            />
          )}

          {(role === LEASING_ADMIN || role === LEASING_KORISNIK) && (
            <Route
              path={NavigationPath.SINGLE_OFFER_RESPONSES_ROUTE}
              element={<ResponseSingle />}
            />
          )}

          {(role === LEASING_ADMIN || role === LEASING_KORISNIK) && (
            <Route
              path={NavigationPath.SINGLE_RESPONSE_ROUTE}
              element={<InsuranceResponseInfo />}
            />
          )}
        </Route>
      </Route>
    </>
  </Routes>
);

export default AppContainer;
